import React, { useState, useEffect } from "react";

// CSS styles
import "bootstrap/dist/css/bootstrap.min.css";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import "react-datepicker/dist/react-datepicker.css";
import "./App.css";

// Pages
import Login from "./pages/Login/Login";
import Patients from "./pages/Reports/Patients";
import Consumers from "./pages/Reports/Consumers";
import UserManage from "./pages/User/UserManage";
import AddUser from "./pages/User/AddUser";
import EditUser from "./pages/User/EditUser";
import AttendanceManage from "./pages/Attendance/AttendanceManage";
import PublicMap from "./pages/PublicMap/PublicMap";
import Trackers from "./pages/Reports/Trackers";

// Components
import SideBar from "./components/Sidebar/SideBar";

// Router
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

// Utils
import { getRole } from "./utils/commons.js";

/* ================= WRAPPER ================= */
function AppWrapper() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}

/* ================= MAIN APP ================= */
function App() {
  const [inactive, setInactive] = useState(true);
  const location = useLocation();

  const toggle = () => {
    setInactive(!inactive);
  };

  /* ✅ Redirect to login if no role */
  useEffect(() => {
    const role = getRole();

    if (
      role == null &&
      location.pathname !== "/" &&
      location.pathname !== "/public_map"
    ) {
      window.location.href = "/";
    }
  }, [location.pathname]);

  /* ✅ Hide sidebar on login + public pages */
  const hideSidebar =
    location.pathname === "/"; //|| location.pathname === "/public_map" 
    
    
   return (
    <div className="d-flex flex-row">
      {!hideSidebar && getRole() !== null && (
        <SideBar toggle={toggle} isOpen={inactive} />
      )}

      <div style={{
        marginLeft: (!hideSidebar && getRole() !== null && inactive) ? "250px" : "0px",
        transition: "margin-left .3s ease-out",
        flex: 1,
        minWidth: 0,
        width: "100%"
      }}>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/public_map" element={<PublicMap setInactive={setInactive} />} />
          <Route path="/tracker-reports" element={<Trackers setInactive={setInactive} />} />
          <Route path="/reports/patients" element={<Patients setInactive={setInactive} />} />
          <Route path="/reports/consumers" element={<Consumers setInactive={setInactive} />} />
          <Route path="/user" element={<UserManage />} />
          <Route path="/user/add" element={<AddUser />} />
          <Route path="/user/edit/:id" element={<EditUser />} />
          <Route path="/attendance" element={<AttendanceManage />} />
        </Routes>
      </div>
    </div>
  );
}

export default AppWrapper;